export function TypingDots() {
  return (
    <span
      data-testid="typing-dots"
      className="inline-flex items-center gap-1.5"
      aria-label="mentor is typing"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-400 fmq-dot-a" />
      <span className="h-1.5 w-1.5 rounded-full bg-amber-400 fmq-dot-b" />
      <span className="h-1.5 w-1.5 rounded-full bg-amber-400 fmq-dot-c" />
    </span>
  );
}
